import {
  PracovnyKrok,
  PracovnyKrokList,
  PracovnyKrokListApi,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import PracovnyKrokListRequest from '../../model/pracovnyKrok/PracovnyKrokListRequest';
import PracovnyKrokRequest from '../../model/pracovnyKrok/PracovnyKrokRequest';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new PracovnyKrokListApi(apiConfiguration(elegislativaPrefixPath));

export const mapPracovnyKrok = (data: PracovnyKrok): PracovnyKrokRequest => ({
  pracovnyKrokId: data.pracovnyKrokId,
  nazov: data.nazov,
  pracovnyKrok: data.pracovnyKrok ? PracovnyKrokEnum[data.pracovnyKrok] : null,
});

const map = (data: PracovnyKrokList): PracovnyKrokListRequest => ({
  pracovneKroky: data.pracovneKroky.map(pracovnyKrok => mapPracovnyKrok(pracovnyKrok)),
});

// eslint-disable-next-line import/prefer-default-export
export const fetchPracovneKroky = async (
  type: string,
  year: number,
  index: number,
  headers?: object,
):
  Promise<ClientResponse<PracovnyKrokListRequest>> => {
  const {
    data,
    status,
  } = await client.getPracovnyKrokList(type, year, index, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
